export default "# where issisi";


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader/dist/cjs.js!./src/blog/2_where.md
// module id = JVAk
// module chunks = 1